<template>
  <div class="home">
    <div>
      <section>
        <div class="py-8 px-8">
          <div class="d-flex flex-wrap align-items-center justify-content-between">
            <div class="col-12 col-lg-auto mb-3 mb-lg-0">
              <div class="d-flex align-items-center">
                <h4 class="mb-0 me-2">{{ $t('subscriptions') }}</h4>
              </div>
            </div>
            <div class="col-12 col-lg-auto d-flex align-items-center gap-2">
              <div class="input-group flex-grow-1" style="border-bottom: 1px solid #ddd;">
                                <input class="form-control border-0 search-input" autocomplete="off" type="text" v-model="search" :placeholder="$t('search')">
                            </div>
              <button @click="showFilters = !showFilters" class="btn btn-outline-secondary d-md-none">
                <AppIcon name="bi-funnel" class="bi bi-funnel" />
              </button>
            </div>
          </div>
        </div>
      </section>

      <!-- Subscription Overview Section -->
      <!-- <section class="px-8 mb-4">
        <SubscriptionOverview />
      </section> -->

      <section class="">
        <div class="px-8">
          <!-- Mobile action buttons -->
          <div class="d-flex d-md-none gap-2 mb-3">
            <button @click="createSubscriptionState = true" class="btn btn-sm btn-success flex-grow-1">
              <PlusIcon class="me-1 client-lucide-icon" :size="15" :stroke-width="1.75" aria-hidden="true" />
              <span>{{ $t('subscription') }}</span>
            </button>
          </div>

          <!-- Filters section -->
          <div class="row align-items-end g-2 mb-4" :class="{'d-none d-md-flex': !showFilters}">
            <div class="col-12 col-md-4">
              <label class="form-label small d-md-none mb-1">{{ $t('status') }}</label>
              <select v-model="status" class="form-select form-select-sm" name="Results" style="cursor:pointer;">
                <option value="all">{{ $t('all') }}</option>
                <option value="active">{{ $t('active') }}</option>
                <option value="canceled">{{ $t('canceled') }}</option>
              </select>
            </div>
            <div class="col d-none d-md-block"></div>
            <div class="col-12 col-md-3 col-lg-2">
              <label class="form-label small d-md-none mb-1">{{$t('filter_by_date')}}</label>
              <select v-model="dateRangeOption" @change="handleDateRangeChange" class="form-select form-select-sm">
                <option value="">{{$t('filter_by_date')}}</option>
                <option value="today">{{$t('today')}}</option>
                <option value="yesterday">{{$t('yesterday')}}</option>
                <option value="this_week">{{$t('this_week')}}</option>
                <option value="last_week">{{$t('last_week')}}</option>
                <option value="this_month">{{$t('this_month')}}</option>
                <option value="custom">{{$t('custom_date')}}</option>
              </select>
            </div>
            <div class="col-12 col-md-3 col-lg-2" v-if="dateRangeOption === 'custom'">
              <label class="form-label small d-md-none mb-1">{{$t('custom_date')}}</label>
              <date-picker :clearable="true" :editable="false" class="w-100" v-model="range" type="date" range :multi-calendars="1" :placeholder="$t('select_date_range')"></date-picker>
            </div>
            <div class="col-md-2 d-none d-md-block">
              <button @click="createSubscriptionState = true" class="btn btn-sm btn-success w-100">
                <PlusIcon class="me-1 client-lucide-icon" :size="15" :stroke-width="1.75" aria-hidden="true" />
                <span>{{ $t('subscription') }}</span>
              </button>
            </div>
          </div>

          <div class="page-table-container mb-6 bg-white rounded shadow">
            <!-- table -->
            <div class="table-responsive">
              <table class="table mb-0 table-borderless table-striped small">
                <thead>
                  <tr class="text-secondary">
                    <sortable-table-header field="reference" label="reference" :sort-field="sortField" :sort-direction="sortDirection" @sort="applySort($event, getSubscriptions)" />
                    <th class="pt-4 pb-3 px-6">{{ $t('client') }}</th>
                    <th class="pt-4 pb-3 px-6">{{ $t('plan') }}</th>
                    <sortable-table-header field="start_date" label="start_date" :sort-field="sortField" :sort-direction="sortDirection" @sort="applySort($event, getSubscriptions)" />
                    <sortable-table-header field="end_date" label="end_date" :sort-field="sortField" :sort-direction="sortDirection" @sort="applySort($event, getSubscriptions)" />
                    <sortable-table-header field="status" label="status" :sort-field="sortField" :sort-direction="sortDirection" @sort="applySort($event, getSubscriptions)" />
                    <th class="pt-4 pb-3 px-6">{{ $t('actions') }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="subscription in subscriptions" :key="subscription.id">
                    <td class="py-5 px-6">
                      <router-link 
                        :to="`/subscriptions/${subscription.id}`" 
                        class="text-primary text-decoration-none fw-semibold"
                      >
                        {{ subscription.reference || subscription.id }}
                      </router-link>
                    </td>
                    <td class="py-5 px-6">{{ subscription?.client?.name }}</td>
                    <td class="py-5 px-6">
                      <div>
                        ({{subscription?.plan?.name}}) {{ subscription?.plan?.price }} {{business.currency}}
                      </div>
                    </td>
                    <td class="py-5 px-6">
                      <div>
                        {{ formatDate(subscription?.start_date) }}
                      </div>
                    </td>
                    <td class="py-5 px-6">
                      <div>
                        {{ formatDate(subscription?.end_date) }}
                      </div>
                    </td>
                    <td class="py-5 px-6">
                      <span :class="['badge', 
                        subscription?.status === 'active' ? 'bg-success' : 
                        subscription?.status === 'canceled' ? 'bg-danger' : 
                        subscription?.status === 'expired' ? 'bg-secondary' : 'bg-secondary']">
                        {{ $t(subscription?.status) }}
                      </span>
                    </td>
                    
                    <td class="py-5 px-6">
                      <div class="btn-group" role="group">
                        <button
                          @click="viewSubscriptionDetails(subscription)"
                          style="padding: 5px;margin: 0;font-size: 12px !important;"
                          class="btn btn-primary btn-xs me-1"
                          :title="$t('details')"
                        >
                          <AppIcon name="bi-eye" class="bi bi-eye" style="font-size:12px" /> {{ $t('details') }}
                        </button>
                        <button
                          @click="editSubscription(subscription)"
                          style="padding: 5px;margin: 0;font-size: 12px !important;"
                          class="btn btn-primary btn-xs me-1"
                          :title="$t('edit')"
                        >
                          <AppIcon name="bi-pencil" class="bi bi-pencil" style="font-size:12px" /> {{ $t('edit') }}
                        </button>
                        <button
                          v-if="subscription?.status === 'active'"
                          @click="cancelSubscription(subscription?.id)"
                          style="padding: 5px;margin: 0;font-size: 12px !important;"
                          class="btn btn-primary btn-xs"
                          :title="$t('cancel')"
                        >
                          <AppIcon name="bi-x-circle" class="bi bi-x-circle" style="font-size:12px" /> {{ $t('cancel') }}
                        </button>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <!-- table -->
            <div v-if="count > subscriptions.length" style="text-align:center;margin-top:1rem;margin-bottom:1rem">
              <compact-pagination :pages="pagination" :current-page="page" @change="getSubscriptions" />
            </div>
            <table-loading-bar v-if="loading" class="page-table-state text-center" />
            <div v-if="loading === false && !subscriptions.length" class="page-table-state text-center" style="padding:1rem">{{ $t('no_subscriptions_found') }}</div>
          </div>
                          <div class="col-sm-7">
        {{$t('show')}}
        <select v-model="per_page" class="form-select mb-3" name="Results" style="cursor:pointer;margin-right: 5px;width:100px;display:inline-block">
          <option value="5">5</option>
          <option value="10">10</option>
          <option value="15">15</option>
          <option value="25">25</option>
          <option value="50">50</option>
          <option value="100">100</option>
        </select>
        {{$t('entities')}}
      </div>

        </div>
      </section>

    </div>

    <!-- Create Subscription Modal -->
    <add-subscription 
      v-if="createSubscriptionState"  
      :state="createSubscriptionState"
      :plans="plans"
      @createSubscription="createSubscription"/>
    <!-- Create Subscription Modal -->

    <!-- client modal -->
    <add-client 
      v-if="createClientState"  
      :state="createClientState"  
      @createClient="createClient"/>
    <!-- client modal -->

    <!-- Edit Subscription Modal -->
    <div class="modal fade" :class="{ show: showEditModal }" tabindex="-1" role="dialog" :style="{ display: showEditModal ? 'block' : 'none' }">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ $t('edit_subscription') }}</h5>
            <button type="button" class="btn-close" @click="showEditModal = false"></button>
          </div>
          <div class="modal-body" style="text-align:left">
            <form @submit.prevent="updateSubscription" class="subscription-form">
              <div class="row">
                <div class="col-sm-6 mb-3">
                  <label class="form-label">{{ $t('client') }}</label>
                  <auto-complete  
                    @emitAutoCompleteClient="emitAutoCompleteClient" 
                    :defaultValue="editForm.client?.name"
                    entity="clients"
                    emitEvent="emitAutoCompleteClient"
                  ></auto-complete>
                </div>
                <div class="col-sm-6 mb-3">
                  <label class="form-label">{{ $t('plan') }}</label>
                  <select v-model="editForm.plan_id" class="form-control" required>
                    <option value="">{{ $t('select_plan') }}</option>
                    <option v-for="plan in plans" :key="plan.id" :value="plan.id">
                      {{ plan.name }} - {{ plan.price }} {{business.currency}}
                    </option>
                  </select>
                </div>
                <div class="col-sm-6 mb-3">
                  <label class="form-label">{{ $t('start_date') }}</label>
                  <input type="date" v-model="editForm.start_date" class="form-control" required />
                </div>
                <div class="col-sm-6 mb-3">
                  <label class="form-label">{{ $t('end_date') }}</label>
                  <input type="date" v-model="editForm.end_date" class="form-control" />
                </div>
                <div class="col-sm-12 mb-3">
                  <collapsible-notes-field v-model="editForm.notes" id="subscription-edit-notes" rows="1" />
                </div>

                <!-- Payment Section -->
                <div class="col-12 mt-3">
                  <hr>
                  <h6 class="mb-3">{{ $t('add_payment') }}</h6>
                  <p class="text-muted small">{{ $t('add_new_payment_transaction') }}</p>
                </div>
                
                <div class="col-sm-6 mb-3">
                  <label class="form-label">{{ $t('payment_status') }}</label>
                  <select v-model="editForm.payment_status" class="form-control">
                    <option value="paid">{{ $t('paid') }}</option>
                    <option value="pending">{{ $t('pending') }}</option>
                    <option value="partial">{{ $t('partial') }}</option>
                    <option value="failed">{{ $t('failed') }}</option>
                  </select>
                </div>

                <div class="col-sm-6 mb-3">
                  <select v-if="!loadingPaymentMethods" v-model="editForm.payment_method" class="form-control" :key="activePaymentMethods.length">
                    <option v-for="method in activePaymentMethods" :key="method.id || method.name" :value="method.slug">
                      {{ method.name }}
                    </option>
                  </select>
                  <div v-else class="form-control">
                    <small class="text-muted">{{ $t('loading') }}...</small>
                  </div>
                </div>

                <div class="col-sm-6 mb-3" v-if="editForm.payment_method == 'cheque'">
                  <label class="form-label">{{ $t('transaction_id') }}</label>
                  <input 
                    type="text" 
                    v-model="editForm.transaction_id" 
                    class="form-control" 
                    :placeholder="$t('transaction_reference')" 
                  />
                </div>

                <div class="col-sm-6 mb-3">
                  <label class="form-label">{{ $t('amount_paid') }}</label>
                  <input 
                    type="number" 
                    step="0.01" 
                    v-model="editForm.amount_paid" 
                    class="form-control"
                    :min="0" 
                  />
                  <small class="text-muted" v-if="editForm.plan_id">
                    {{ $t('plan_price') }}: {{ getSelectedPlanPrice(editForm.plan_id) }}
                  </small>
                </div>

                <div class="col-sm-6 mb-3">
                  <label class="form-label">{{ $t('balance_due') }}</label>
                  <div class="p-1" style="font-size:18px;font-weight:bold">{{ formatMoney(editBalanceDue) }}</div>
                </div>
              </div>
            </form>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="showEditModal = false">{{ $t('close') }}</button>
            <button type="button" class="btn btn-primary" @click="updateSubscription" :disabled="loading">{{ $t('save_changes') }}</button>
          </div>
        </div>
      </div>
    </div>
    <!-- Edit Subscription Modal -->
  </div>
</template>

<script>
import helper from '../helper';
import moment from 'moment';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import AutoComplete from '../components/autocomplete/AutoComplete';
import AddClient from '../components/AddClient.vue';
import AddSubscription from '../components/AddSubscription.vue';
import sortableList from '../mixins/sortableList'
import { getDefaultPaymentMethods } from '../constants/paymentMethods'
// import SubscriptionOverview from '../components/SubscriptionOverview.vue';

export default {
  name: 'Subscriptions',
  persistedFilterState: {
    key: 'subscriptions',
    fields: ['search', 'status', 'dateRangeOption', 'range', 'start', 'end', 'per_page', 'sortField', 'sortDirection'],
    dateFields: ['range'],
  },
  mixins: [sortableList],
  components: {
    DatePicker,
    AutoComplete,
    AddClient,
    AddSubscription
  },
  data() {
    return {
      subscriptions: [],
      clients: [],
      plans: [],
      showCreateModal: false,
      showEditModal: false,
      showAttendanceModal: false,
      search: '',
      status: 'all',
      showFilters: false,
      attendanceRecords: [],
      loading: false,
      range: [],
      start: null,
      end: null,
      page: 1,
      count: 0,
      pagination: [],
      per_page: 25,
      createClientState: false,
      createSubscriptionState: false,
      dateRangeOption: '',
      subscriptionForm: {
        client_id: '',
        plan_id: '',
        start_date: new Date().toISOString().substr(0, 10),
        notes: ''
      },
      editForm: {
        id: null,
        client_id: '',
        client: null,
        plan_id: '',
        start_date: '',
        end_date: '',
        notes: '',
        payment_status: '',
        payment_method: '',
        amount_paid: '',
        transaction_id: ''
      },
      paymentMethods: [],
      loadingPaymentMethods: false
    };
  },
  watch: {
    status() {
      this.getSubscriptions();
    },
    async search(){
        if(this.search.length > 2){
           this.getSubscriptions()
        }
        if(this.search == '') return this.getSubscriptions()
    },
    range() {
      if (this.range[0] == null) {
        this.start = null;
        this.end = null;
        this.getSubscriptions();
      }

      if (this.range.length && this.range[0] && this.range[1]) {
        this.start = moment(this.range[0]).format('YYYY-MM-DD');
        this.end = moment(this.range[1]).format('YYYY-MM-DD');
        this.getSubscriptions();
      } else {
        this.subscriptions = [];
      }
    },
    per_page() {
      this.getSubscriptions(this.page);
    },
    'editForm.amount_paid'(newAmount) {
      if (!this.editForm.plan_id || !this.plans) return;
      const plan = this.plans.find(p => p.id == this.editForm.plan_id);
      if (!plan) return;
      
      const total = plan.price;
      const amountPaid = parseFloat(newAmount) || 0;
      
      if (amountPaid >= total) {
        this.editForm.payment_status = 'paid';
      } else if (amountPaid > 0 && amountPaid < total) {
        this.editForm.payment_status = 'partial';
      } else if (amountPaid == 0) {
        this.editForm.payment_status = 'pending';
      }
    },
    'editForm.payment_status'(newVal) {
      if (newVal == 'paid' && this.editForm.plan_id && this.plans) {
        const plan = this.plans.find(p => p.id == this.editForm.plan_id);
        if (plan) {
          this.editForm.amount_paid = plan.price;
        }
      }
    }
  },
  methods: {
    async getSubscriptions(page) {
      try {
        this.loading = true;
        this.page = page ? page : 1;
        this.subscriptions = this.page == 1 ? [] : this.subscriptions;
        
        const params = new URLSearchParams({ page: this.page, per_page: this.per_page });
        this.appendSortParams(params);
        
        if (this.status !== 'all') {
          params.append('status', this.status);
        }
        
        if(this.search != "") {
          params.append('keyword', this.search);
        }

        if (this.start && this.end) {
          params.append('start', this.start);
          params.append('end', this.end);
        }
        const url = `${process.env.VUE_APP_API}/subscriptions?${params.toString()}`;
        
        const response = await helper.customGet(url);
        this.subscriptions = response.data.data;
        
        if(this.per_page != response.data.per_page) {
          this.per_page = response.data.per_page;
        }

        this.page = response.data.current_page;
        this.count = response.data.count;
        this.loading = false;

        //pagination
        this.pagination = [];
        let MaxPagination = Math.ceil(this.count / this.per_page);
        for(let i = 1; i <= MaxPagination; i++) {
          this.pagination.push(i);
        }
      } catch (error) {
        this.loading = false;
        window.vueOpener.open({
          message: this.$t('failed_to_fetch_subscriptions'),
          type: 'error',
          position: 'bottom'
        });
      }
    },
    async getClients() {
      try {
        const response = await helper.customGet(`${process.env.VUE_APP_API}/clients`);
        this.clients = response.data.data;
      } catch (error) {
        window.vueOpener.open({
          message: this.$t('failed_to_fetch_clients'),
          type: 'error',
          position: 'bottom'
        });
      }
    },
    async getPlans() {
      try {
        const response = await helper.customGet(`${process.env.VUE_APP_API}/plans`);
        this.plans = response.data.data;
      } catch (error) {
        window.vueOpener.open({
          message: this.$t('failed_to_fetch_plans'),
          type: 'error',
          position: 'bottom'
        });
      }
    },
    async saveSubscription() {
      try {
        this.loading = true;
        await helper.customPost(`${process.env.VUE_APP_API}/subscriptions`, this.subscriptionForm, { showToast: true });
        await this.getSubscriptions();
        this.showCreateModal = false;
        this.loading = false;
        this.resetForm();
      } catch (error) {
        this.loading = false;
        window.vueOpener.open({
          message: this.$t('failed_to_create_subscription'),
          type: 'error',
          position: 'bottom'
        });
      }
    },
    async cancelSubscription(id) {
      if (confirm(this.$t('are_you_sure_cancel_subscription') || 'Are you sure you want to cancel this subscription?')) {
        try {
          await helper.customPatch(`${process.env.VUE_APP_API}/subscriptions/${id}`, { status: 'canceled' }, { showToast: true });
          await this.getSubscriptions();
        } catch (error) {
          window.vueOpener.open({
            message: this.$t('failed_to_cancel_subscription'),
            type: 'error',
            position: 'bottom'
          });
        }
      }
    },
    async viewAttendance(subscription) {
      try {
        const response = await helper.customGet(`${process.env.VUE_APP_API}/subscriptions/${subscription.id}/attendance`);
        this.attendanceRecords = response.data;
        this.showAttendanceModal = true;
      } catch (error) {
        window.vueOpener.open({
          message: this.$t('failed_to_fetch_attendance_records'),
          type: 'error',
          position: 'bottom'
        });
      }
    },
    async viewSubscriptionDetails(subscription) {
      // Navigate to subscription details page
      this.$router.push({ path: `/subscriptions/${subscription.id}` });
    },
    formatDate(date) { return helper.formatDate(date) },
    formatTime(date) { 
      return new Date(date).toLocaleTimeString();
    },
    resetForm() {
      this.subscriptionForm = {
        client_id: '',
        plan_id: '',
        start_date: new Date().toISOString().substr(0, 10),
        notes: ''
      };
    },
    emitAutoCompleteClient(data) {
      this.subscriptionForm.client_id = data.result.id;
      this.subscriptionForm.client = data.result;
    },
    openCreateClientModal() {
      this.createClientState = !this.createClientState;
    },
    createClient(data) {
      if (data.client) {
        this.subscriptionForm.client_id = data.client.id;
        this.subscriptionForm.client = data.client;
      }
      if (data && data.state != undefined) {
        this.createClientState = data.state;
      }
    },
    editSubscription(subscription) {
      this.editForm = {
        id: subscription.id,
        client_id: subscription.client_id,
        client: subscription.client,
        plan_id: subscription.plan_id,
        start_date: subscription.start_date,
        end_date: subscription.end_date,
        notes: subscription.notes || '',
        payment_status: '',
        payment_method: 'cash',
        amount_paid: '',
        transaction_id: ''
      };
      this.showEditModal = true;
    },
    async updateSubscription() {
      try {
        this.loading = true;
        await helper.customPatch(`${process.env.VUE_APP_API}/subscriptions/${this.editForm.id}`, this.editForm);
        await this.getSubscriptions();
        this.showEditModal = false;
        this.loading = false;
      } catch (error) {
        this.loading = false;
        window.vueOpener.open({
          message: this.$t('failed_to_update_subscription'),
          type: 'error',
          position: 'bottom'
        });
      }
    },
    createSubscription(data) {
      if (data.subscription) {
        this.getSubscriptions();
      }
      if (data && data.state != undefined) {
        this.createSubscriptionState = data.state;
      }
    },
    getSelectedPlanPrice(planId) {
      if (!planId || !this.plans) return '';
      const plan = this.plans.find(p => p.id == planId);
      return plan ? `${plan.price} ${this.business.currency}` : '';
    },
    formatMoney(number) {
      return helper.formatMoney(number);
    },
    // Handle date range selection
    handleDateRangeChange() {
      if (this.dateRangeOption === '') {
        this.range = []
        this.start = null
        this.end = null
        this.getSubscriptions()
      } else if (this.dateRangeOption === 'today') {
        const start = new Date()
        const end = new Date()
        this.range = [start, end]
      } else if (this.dateRangeOption === 'yesterday') {
        const start = new Date()
        const end = new Date()
        start.setTime(start.getTime() - 3600 * 1000 * 24)
        end.setTime(end.getTime() - 3600 * 1000 * 24)
        this.range = [start, end]
      } else if (this.dateRangeOption === 'this_week') {
        const start = new Date()
        const end = new Date()
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
        this.range = [start, end]
      } else if (this.dateRangeOption === 'last_week') {
        const start = new Date()
        const end = new Date()
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 14)
        end.setTime(end.getTime() - 3600 * 1000 * 24 * 7)
        this.range = [start, end]
      } else if (this.dateRangeOption === 'this_month') {
        const start = new Date()
        const end = new Date()
        start.setDate(1)
        this.range = [start, end]
      } else if (this.dateRangeOption === 'custom') {
        this.range = []
      }
    },
    async fetchPaymentMethods(forceDefault = false) {
      this.loadingPaymentMethods = true
      try {
        const response = await helper.customGet(`${process.env.VUE_APP_API}/payment-methods?per_page=100`)
        this.paymentMethods = response.data.data || []
        
        // If no payment methods exist, use the standard defaults
        if (this.paymentMethods.length === 0) {
          this.paymentMethods = getDefaultPaymentMethods()
        }
        
        // Wait for loading to complete before setting default
        this.loadingPaymentMethods = false
        
        // Set the default payment method if not already defined or if forced
        if (forceDefault || !this.editForm.payment_method || this.editForm.payment_method === '') {
          await this.$nextTick()
          
          const defaultMethod = this.paymentMethods.find(method => method.is_default === true)
          let defaultSlug = 'cash'
          
          if (defaultMethod) {
            defaultSlug = defaultMethod.slug
          } else {
            const firstActiveMethod = this.paymentMethods.find(method => method.is_active === true)
            defaultSlug = firstActiveMethod ? firstActiveMethod.slug : 'cash'
          }
          
          this.editForm.payment_method = defaultSlug
          await this.$nextTick()
        }
      } catch (error) {
        this.paymentMethods = getDefaultPaymentMethods()
        this.loadingPaymentMethods = false
        if (forceDefault || !this.editForm.payment_method || this.editForm.payment_method === '') {
          await this.$nextTick()
          this.editForm.payment_method = 'cash'
        }
      }
    }
  },
  computed : {
    business(){ return this.$store.getters.BUSINESS},
    isFormValid() {
      return this.subscriptionForm.client_id && this.subscriptionForm.plan_id;
    },
    editBalanceDue() {
      if (!this.editForm.plan_id || !this.plans) return 0;
      const plan = this.plans.find(p => p.id == this.editForm.plan_id);
      if (!plan) return 0;
      return plan.price - (parseFloat(this.editForm.amount_paid) || 0);
    },
    activePaymentMethods(){
        // Filter only active payment methods or return the standard defaults
        const activeMethods = this.paymentMethods.filter(method => method.is_active)
        
        // Keep payment options available if the API cannot provide them
        if (activeMethods.length === 0) {
            return getDefaultPaymentMethods()
        }
        
        return activeMethods
    }
  },
  async mounted() {
    window.mixpanel.track("subscriptions");
    //check permissions
    if(helper.checkAccess('view_subscriptions') == -1) return this.$router.push({path : '/'})
    if(helper.checkAccess('view_subscriptions') == -2) return this.$router.push({path : '/subscribe'})

    // Fetch payment methods
    await this.fetchPaymentMethods(true);

    // Initialize this_month date range
    // this.handleDateRangeChange();

    this.getSubscriptions();
    this.getClients();
    this.getPlans();
  }
};
</script>

<style scoped>
.table-borderless>:not(caption)>*>* {
  padding: 5px !important;
}

.badge {
  padding: 0.25rem 0.5rem;
  border-radius: 4px;
  font-size: 0.875rem;
  text-transform: capitalize;
}

.badge.active {
  background: #198754;
  color: white;
}

.badge.expired {
  background: #ffebee;
  color: #c62828;
}

.badge.canceled {
  background: #dc3545;
  color: white;
}

.badge.paid {
  background: #e8f5e9;
  color: #2e7d32;
}

.badge.pending {
  background: #fff3e0;
  color: #ef6c00;
}

.badge.failed {
  background: #ffebee;
  color: #c62828;
}

.attendance-list {
  max-height: 400px;
  overflow-y: auto;
}

.attendance-record {
  padding: 1rem;
  border-bottom: 1px solid #eee;
}

.record-header {
  display: flex;
  justify-content: space-between;
  margin-bottom: 0.5rem;
}

.record-details {
  color: #666;
}

.modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1040;
}

.modal {
  z-index: 1050;
}

.btn-xs {
  padding: 0.25rem 0.5rem;
  font-size: 0.75rem;
  line-height: 1.5;
  border-radius: 0.2rem;
}
</style>
